export const LocalStoreLocaleKey = "OwaLocale";
